export const makeNewsSchema = (params) => {
    return {
        '@type': 'NewsArticle',
        name: params.title,
        creator: params.author,
        abstract: params.abstract,
        image: params.image,
        url: params.siteUrl + '/news/' + params.url,
        datePublished: params.publishedDate,
    };
};
